module.exports = __webpack_public_path__ + "img/JP_WOMAN_IDLE.e0a39680.png";